import { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
// utils
import axios from '../utils/axios';
import { isValidToken, setSession } from '../utils/jwt';
import { adminProfile } from '../services/admin';
import { getAdminProfile } from '../redux/slices/user';
import { store } from '../redux/store';
import api from '../services/api';
import { PATH_AUTH } from 'src/routes/paths';
// import { getClientMode, setClientMode } from '../utils';

// ----------------------------------------------------------------------

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: {},
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const mainStore = store;
  // console.log({ state });
  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');

        if (accessToken) {
          setSession(accessToken);

          // const {data} = await adminProfile();
          // const { user } = response.data;
          const userData = await mainStore.dispatch(getAdminProfile());

          if (userData?.data?.can_login == 0) {
            logout();
            window.location.href = PATH_AUTH.login;
          }

          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user: userData,
            },
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const login = async (phoneOrEmail, password) => {
    console.log('login start');
    const response = await axios.post(api.auth.login, {
      phoneOrEmail,
      password,
    });

    console.log({ response });
    const token = response.data?.token;
    // const accessToken = "kldlsdjlkfslkdjflksjdlkjsldjflsd";

    setSession(token);
    dispatch({
      type: 'LOGIN',
      payload: {
        user: {},
      },
    });
    const userData = await mainStore.dispatch(getAdminProfile());

    dispatch({
      type: 'INITIALIZE',
      payload: {
        isAuthenticated: true,
        user: userData,
      },
    });
    // setClientMode(false);
  };

  const publicLogin = async (codeMelli, phone) => {
    console.log('login start');
    const response = await axios.post(api.client.auth.login, {
      phone,
      code_melli: codeMelli,
    });

    console.log({ response });
    // const token = response.data?.token;
    // const accessToken = "kldlsdjlkfslkdjflksjdlkjsldjflsd";

    // setSession(token);
    // dispatch({
    //   type: 'LOGIN',
    //   payload: {
    //     user: {},
    //   },
    // });

    return response;
  };

  const publicVerify = async (codeMelli, code) => {
    console.log('verify start');
    const response = await axios.post(api.client.auth.verify, {
      verify_code: code,
      code_melli: codeMelli,
    });
    const token = response.data?.token;
    setSession(token);
    // setClientMode(true);
    console.log({ response });
    dispatch({
      type: 'LOGIN',
      payload: {
        user: {},
      },
    });
    return response;
  };

  const register = async (email, password, firstName, lastName) => {
    const response = await axios.post('/api/account/register', {
      email,
      password,
      firstName,
      lastName,
    });
    const { token } = response.data;

    window.localStorage.setItem('accessToken', token);
    dispatch({
      type: 'REGISTER',
      payload: {
        user: {},
      },
    });
  };

  const logout = async () => {
    setSession(null);
    // setClientMode(false);
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        register,
        publicLogin,
        publicVerify,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
